import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography } from '@mui/material';
import { ProficiencyStandard } from '@/hooks/useProficiencyStandards'; // Assuming path is correct

interface StandardSelectionDropdownProps {
  standards: ProficiencyStandard[];
  selectedStandardId?: string;
  onChange: (standardId: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

const StandardSelectionDropdown: React.FC<StandardSelectionDropdownProps> = ({
  standards,
  selectedStandardId,
  onChange,
  disabled = false,
  error = false,
  helperText,
}) => {
  if (!standards || standards.length === 0) {
    return <Typography variant="body2">No proficiency standards available.</Typography>;
    // Or return a disabled Select with a message
  }

  return (
    <FormControl fullWidth error={error} disabled={disabled}>
      <Select
        id="standard-selection"
        value={selectedStandardId || ''}
        onChange={(e) => onChange(e.target.value as string)}
        sx={{
          borderRadius: '16px',
          '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #D0D5DD !important',
              borderRadius: '16px !important',
            },
            '& .MuiInputBase-input': {
              padding: '14px',
              color: '#344054',
              fontWeight: 500,
            },
            '&.MuiInputBase-root': {
              height: 44,
              background: '#FFF',
              // maxWidth: maxWidth,
              width: '100%',
          },
        }}
      >
        <MenuItem value="">
          <em>Select a Standard</em>
        </MenuItem>
        {standards.map((standard) => (
          <MenuItem key={standard.id} value={standard.id}>
            {standard.name}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default StandardSelectionDropdown; 